export default __webpack_public_path__ + "static/media/notification-bell-red.d590f1d4.png";